import React, { useEffect, useState } from 'react';
import { Button, Table, message } from 'antd';
import { UserOrders } from '../../schema/order';
import { getAllOrdersForProduct, replaceSomeOrders } from '../../config/api-routes';
import api from '../../config/axios';
import { useNavigate } from 'react-router-dom';

function ReplaceSomeCustomerOrderTable({
  recordId,
  closeModal,
  selectedOrderFormId,
  userRecord,
  selectedProduct,
}: any) {
  const [dataSource, setDataSource] = useState<UserOrders[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState<UserOrders[]>([]);
  const [quantityTotal, setQuantityTotal] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (Number(recordId) > 0) {
      fetchOrdersById();
    }
  }, [recordId]);

  const fetchOrdersById = async () => {
    setLoading(true);
    api
      .get<never, UserOrders[]>(`${getAllOrdersForProduct}/${Number(recordId)}`)
      .then((result) => {
        setDataSource(result);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const handleReplaceSome = () => {
    setLoading(true);

    const orderIds = selectedRows.map((item) => item.orderId);

    const payload = {
      changedId: recordId,
      replaceId: selectedProduct[0].id,
      orders: orderIds,
    };

    api
      .put(`${replaceSomeOrders}`, payload)
      .then((res: any) => {
        setLoading(false);
        message.success(res?.message);
        navigate('/order-inventory');
      })
      .catch((error) => {
        setLoading(false);
        message.error(error?.response?.data?.message);
      });
  };

  const columns = [
    {
      title: ' Quantity ',
      dataIndex: 'quantity',
    },
    {
      title: 'Ordered Quantity',
      dataIndex: 'orderedQuantity',
    },
    {
      title: 'Customer Name',
      dataIndex: 'customerName',
    },
    {
      title: 'Order Number',
      dataIndex: 'orderNumber',
    },
    {
      title: 'Applied Tier',
      dataIndex: 'appliedTier',
    },
    {
      title: 'Invoiced',
      dataIndex: 'isInvoiced',
      render: (text: any) => {
        const isInvoiced = (text) ? 'Yes':'No';
        return isInvoiced;
      },
      filters: [
        {
          text: 'Yes',
          value: true,
        },
        {
          text: 'No',
          value: false,
        }
      ],
      onFilter: (value:any , record:any) => {
        return record.isInvoiced === value;
      }
    },
    {
      title: 'Picklist Printed',
      dataIndex: 'plPrintedCount',
      render: (text: any) => {
        const isPlPrinted = (text) ? 'Yes':'No';
        return isPlPrinted;
      },
      filters: [
        { text: 'Yes', value: 'yes' },
        { text: 'No', value: 'no' },
      ],
      onFilter: (value:any, record:any) => {
        if (value === 'yes') return record.plPrintedCount > 0;
        if (value === 'no') return record.plPrintedCount === 0 || !record.plPrintedCount;
        return true;
      },
    },
    {
      title: 'Price per piece',
      dataIndex: 'pricePerPiece',
    },
    {
      title: 'Shipping Week',
      dataIndex: 'shippingWeek',
      render: (value: any) => {
          const text = String(value ?? ''); // ensure string
          if (text.length < 5) return text; // not valid, just return

          let week: string;
          let year: string;

          if (text.length === 6) {
            // e.g. "412025"
            week = text.slice(0, 2);
            year = text.slice(2);
          } else if (text.length === 5) {
            // e.g. "92025"
            week = text.slice(0, 1).padStart(2, '0'); // add leading zero
            year = text.slice(1);
          } else {
            return text; // fallback for unexpected formats
          }

          return <span>{week}, {year}</span>;
        }
    }
  ];

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: UserOrders[]) => {
      setSelectedRows(selectedRows);
      const selectedQuantityTotal = selectedRows.reduce((acc, item) => acc + item.quantity, 0);
      setQuantityTotal(selectedQuantityTotal);
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.id === recordId, // Column configuration not to be checked
      name: record.name,
    }),
  };

  return (
    <div className='px-2 pt-2'>
      <div>
        <div className='d-flex align-items-center pb-2' style={{ justifyContent: 'space-between' }}>
          <div className='d-flex gap-4'>
            <div className='d-flex gap-2'>
              <b className='secondary-color'>Selected Quantity:</b> <span>{quantityTotal}</span>
            </div>
          </div>
          <div className='align-self-center'>
            <Button
              onClick={handleReplaceSome}
              disabled={!selectedRows.length || !selectedProduct.length}
              className='d-flex table-title-row'
              type='primary'
            >
              Replace
            </Button>
          </div>
        </div>
      </div>

      <Table
        scroll={{ y: '55vh' }}
        className='pt-2'
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        loading={loading}
        rowClassName={() => 'editable-row'}
        rowKey='id'
        bordered
        pagination={false}
        dataSource={dataSource}
        columns={columns}
      />
    </div>
  );
}

export default ReplaceSomeCustomerOrderTable;
